import { createAction } from '@saucelabs/sl-util-redux';

import * as types from './types';


export const selectOwner = createAction(types.SELECT_OWNER);
export const clearOwner = createAction(types.CLEAR_OWNER);
export const toggleStatus = createAction(types.TOGGLE_STATUS);
export const clearStatuses = createAction(types.CLEAR_STATUSES);
export const updateOwnerFilter = createAction(types.UPDATE_OWNER);
